import { useAuthStore } from '../stores/auth.store';

/**
 * useAuth Hook
 *
 * Convenience hook to access auth state and actions.
 *
 * @example
 * ```tsx
 * const { user, isAuthenticated, login, logout } = useAuth();
 * ```
 */
export function useAuth() {
  const {
    user,
    token,
    refreshToken,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    checkAuth,
    clearError,
    forgotPassword,
    resetPassword,
  } = useAuthStore();

  return {
    user,
    token,
    refreshToken,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    checkAuth,
    clearError,
    forgotPassword,
    resetPassword,
  };
}
